import utils from 'utils';

/* <div data-truncate-chars="130" class="js-truncate d-n@<md">
  <div class="js-truncate-content">{{ country.getVillageHomeOwnerText()|raw }}</div>
  <button class="mt-xs d-f ai-c fs-xxs fw-700 js-truncate-trigger">Afficher plus</button>
</div>*/

// SM ONLY TRUNCATE
/* <div data-truncate-chars="130" data-truncate-sm-only class="js-truncate d-n@<md">
  <div class="js-truncate-content">{{ country.getVillageHomeOwnerText()|raw }}</div>
  <button class="mt-xs d-f ai-c fs-xxs fw-700 js-truncate-trigger">Afficher plus</button>
</div>*/

class Truncate {
  constructor(elem) {
    this.elem = elem;
    this.truncated = false;
    this.trigger = this.elem.querySelector('.js-truncate-trigger');
    this.contentElem = this.elem.querySelector('.js-truncate-content');
    this.originalContent = this.contentElem.innerHTML;
    this.strippedOriginalContent = utils.htmlStripTag(this.originalContent).trim();
    this.isSmOnlyTruncate = this.elem.hasAttribute('data-truncate-sm-only');
    this.unTruncated = this.elem.hasAttribute('data-untruncated');

    this.canBeTruncated = (this.strippedOriginalContent.length > this.elem.dataset.truncateChars) && ((this.isSmOnlyTruncate && utils.mq.sm.matches) || !this.isSmOnlyTruncate);
    // const truncateChars = parseInt(this.elem.dataset.truncateChars, 10);
    // this.canBeTruncated = (this.strippedOriginalContent.length > truncateChars) && ((this.isSmOnlyTruncate && utils.mq.sm.matches) || !this.isSmOnlyTruncate);
    this.truncatedContent = utils.truncateHtml(this.originalContent, this.elem.dataset.truncateChars);

    if (this.canBeTruncated) {
      this.truncate();
    } else {
      this.trigger && this.trigger.classList.add('d-n');
    }

    this.events();
  };

  changeTriggerLabel() {
    if (this.trigger.dataset.truncateToggledLabel) {
      const currentLabel = `${this.trigger.textContent}`;
      this.trigger.textContent = this.trigger.dataset.truncateToggledLabel;
      this.trigger.dataset.truncateToggledLabel = currentLabel;
    }
  };

  events() {
    if (this.trigger) {
      this.trigger.addEventListener('click', e => {
        this.truncate();
      });
    }

    if (this.isSmOnlyTruncate) {
      utils.mq.sm.addListener(e => {
        if (e.matches) {
          this.truncate();
        } else {
          this.untruncate();
        }
      });
    }

    if(this.unTruncated) {
      this.untruncated();
    }
  };

  truncate() {
    this.contentElem.innerHTML = this.truncated ? this.originalContent : this.truncatedContent;
    this.truncated = !this.truncated;
    if (this.trigger) {
      this.truncated ? this.trigger.classList.remove('active') : this.trigger.classList.add('active');
      this.changeTriggerLabel();
    }
  };

  untruncate() {
    this.contentElem.innerHTML = this.originalContent;
    this.trigger.classList.remove('active');

    if (this.truncated) {
      this.changeTriggerLabel();
      this.truncated = false;
    }
  };

  untruncated() {
    this.contentElem.innerHTML = this.originalContent;
    this.trigger.classList.add('active');
    this.changeTriggerLabel();
    this.truncated = false;
  };
}

document.addEventListener('reviewsRendered', () => {
  const truncateElems = document.querySelectorAll('.js-truncate');
  for (let truncateElem of truncateElems) {
      truncateElem.truncate = new Truncate(truncateElem);
  }
});